module.exports = __webpack_public_path__ + "img/india.3a4322b.webp";